module.exports = __webpack_public_path__ + "static/media/ai-Code.3f6773a8.png";